// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Cl1-","buttons":"Footer_buttons__1_D41"};